import { useId } from 'react';
import { FilterModalTextInput } from './FilterModal';

export type LocationValue = string | undefined;

export const LocationFilter = (props: {
    value: LocationValue;
    onLocationChange: (newLocation: LocationValue) => void;
    headerMessageId?: string;
}) => {
    const inputId = useId();
    const header = props.headerMessageId ?? 'outboundOrderBook.common.filter.location';

    return (
        <div className="margin-top-20">
            <FilterModalTextInput
                id={inputId}
                headerMessageId={header}
                inputAddon="rioglyph rioglyph-poi"
                placeholderMessageId="outboundOrderBook.common.filter.enterLocation"
                isOptional
                value={props.value}
                onChange={(event) => {
                    const value = event.currentTarget.value;
                    props.onLocationChange(value === '' ? undefined : value);
                }}
            />
        </div>
    );
};
